module.exports = __webpack_public_path__ + "1d16d2c598ebdd5229e2bd63493adbd1.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-24.png
// module id = 116
// module chunks = 0